import React, { useState, useEffect, useMemo, useRef } from "react";
import styles from "./EMIRepayment.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import EMIsAPI from "../../services/emi-api";
import moment from "moment";
import FetchingRepayment from "./FetchingRepayment/FetchingRepayment";
import { getLeadID } from "../../utils/storage";
import { redirectToExternalURL } from "../../utils/utils";
import { 
  clevertap_loan_repayment_lending_screen,  
  clevertap_loan_repayment_lending_screen_click
} from "../../lib/clevertap-events";

export default function EMIRepayment() {
  const isCTEventOnLoadTrigger = useRef(false)
  const [data, setData] = useState(null);
  const {isLentracustomer,isLentraPushed , loanSummary: {lmsId, losId}={}} = data || {};
  const isLastEmiDue = data?.loanSummary?.isLastEmiDue;
  //const isLastEmiUnpaid = data?.getEmis?.at(-1)?.isLastUnpaidEmi;
  const shouldShowRepayButton = data?.shouldShowRepayButton;
  const { repaymentDataAPI, getLentraFundIn } = useMemo(() => new EMIsAPI(), []);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchAPI = async () => {
      const res = await repaymentDataAPI();
      if (res.success) {
        setData(res.data);
      } 
    };

    fetchAPI();
  }, []);

  useEffect(() => {
    if(data?.loanSummary && !isCTEventOnLoadTrigger.current) {
      isCTEventOnLoadTrigger.current = true;
      clevertap_loan_repayment_lending_screen({
        amount: data.loanSummary.principal
      });
    }
  }, [data])

  const overdueStatus = data && data?.getEmis?.find((item) => item.status === "Overdue");
  //  const isRepayAllVisible = (isLentracustomer && isLastEmiUnpaid) || !isLentracustomer;
  const isRepayAllVisible = (isLentracustomer && shouldShowRepayButton) || !isLentracustomer;
   const isLentraPushedVisible = (isLentracustomer && isLentraPushed) || !isLentracustomer;

  const lentraRepayment = async (payload) => {
    try {
      const res =  await getLentraFundIn(payload);
      const { statusCode, data } = res;
      if(statusCode === 200 && data?.url){
        redirectToExternalURL(data?.url)
      }
    } catch (error) {
      console.error("Lentra Repayment Error: ", error);
    }
    
  };

  if (!data || !Object.keys(data).length) {
    return null;
  }


const handleClick = () => {
  navigate(
    '/re-payment',
    isLentracustomer ? { state: { emis: data?.getEmis } } : {}
  );
};


  return (
    <>
      {data.getEmis.length > 0 && isLentraPushedVisible ? (
        <div className={styles.emiRepayment}>
          {/* Cash */}
          <div className={styles.cash}>
            <div>
              <h3>
                Cash Loan <span>₹{data.loanSummary.principal}</span>
              </h3>
              <p>
                Final Date <span>{moment(data?.getEmis.at(-1)?.dueDate).format("MMM D, YYYY")}</span>
              </p>
            </div>
            <div>
              <Link to="/loan-details">
                <MdKeyboardArrowRight size={30} color="#b7b1b1" />
              </Link>
            </div>
          </div>

          {isLentracustomer && (
            <div className={styles.paymentInfo}>
              <span>•</span>
              Early EMI payments will be settled on the due date.
            </div>
          )}

          {/* EMIs List */}
          <div className={styles.emis}>
            {data?.getEmis
              ?.filter((item) => item.status !== "Paid")
              .slice(0, 3)
              .map((item, index) => (
                <React.Fragment key={index}>
                  <div className={`${styles.emiList} ${item.status === "Overdue" ? styles.emiListOverdue : ""}`}>
                    <div className={styles.emiAmount}>
                      <div className={styles.number}>1</div>
                      <div>
                        <p className={styles.amount}>₹{item.amountPayable}</p>
                        <p className={styles.date}>on {moment(item.dueDate).format("Do MMM, YYYY")}</p>

                        {item.status === "Overdue" && (
                          <div className={styles.overdueDay}>
                            {moment().diff(moment(item.dueDate), "days")} days Overdue
                          </div>
                        )}
                      </div>
                    </div>

                    {index === 0 && (
                      <button
                        className={styles.repay}
                        onClick={() => {
                          clevertap_loan_repayment_lending_screen_click({
                            amount: item?.amountPayable,
                            due_date: item?.dueDate,
                            CTA: 'Repay',
                          });
                          if(isLentracustomer){
                            if(data?.isLastEmiUnpaid){
                               navigate("/re-payment");
                               return;
                            }else{
                              navigate("/re-payment", { state: { isForeClosure:false } });
                               return;
                            }
                          } else{
                           navigate("/re-payment")
                          }                
                        }}
                      >
                        Repay
                      </button>
                    )}
                  </div>
                </React.Fragment>
              ))}
          </div>

          {/* Buttons */}
          <div className={styles.button}>
            <button className={styles.btn} onClick={() => navigate("/loan-details")}>
              View All
            </button>
           { isRepayAllVisible ? <button
           className={`${styles.btn} ${styles.btnActive}`}
          onClick={handleClick}
          >
         Repay All
        </button> : null}
          </div>
        </div>
      ) : (
        <FetchingRepayment />
      )}

      {overdueStatus && <div className={styles.delayRepayment}>Delays in repayment may affect your CIBIL score</div>}
    </>
  );
}
